import { compose, withState, lifecycle, withHandlers } from "recompose";

export default compose(
  withState("width", "setWidth", window.innerWidth),
  withHandlers({
    updateDimensions: ({ setWidth }) => () => setWidth(window.innerWidth)
  }),
  lifecycle({
    componentDidMount() {
      const { updateDimensions } = this.props;
      updateDimensions();
      window.addEventListener("resize", updateDimensions);
    }
  })
);
